import { clearFacetSearch } from '../../../../features/facets/facet-search-set/generic/generic-facet-search-actions.js';
import { updateFacetSearch } from '../../../../features/facets/facet-search-set/specific/specific-facet-search-actions.js';
export function buildGenericFacetSearch(engine, props) {
    const dispatch = engine.dispatch;
    const { options, getFacetSearch, executeFacetSearchActionCreator, executeFieldSuggestActionCreator, } = props;
    const { facetId } = options;
    return {
        /** Updates the facet search query.
         * @param text The new query.
         */
        updateText(text) {
            dispatch(updateFacetSearch({
                facetId,
                query: text,
                numberOfValues: getFacetSearch().initialNumberOfValues,
            }));
        },
        /** Increases number of results returned by numberOfResults */
        showMoreResults() {
            const { initialNumberOfValues, options } = getFacetSearch();
            dispatch(updateFacetSearch({
                facetId,
                numberOfValues: options.numberOfValues + initialNumberOfValues,
            }));
            dispatch(props.isForFieldSuggestions
                ? executeFieldSuggestActionCreator(facetId)
                : executeFacetSearchActionCreator(facetId));
        },
        /** Executes a facet search to update the values.*/
        search() {
            dispatch(props.isForFieldSuggestions
                ? executeFieldSuggestActionCreator(facetId)
                : executeFacetSearchActionCreator(facetId));
        },
        /** Resets the query and empties the values. */
        clear() {
            dispatch(clearFacetSearch({ facetId }));
        },
        /**
         * Updates the facet value captions.
         * @param captions - A dictionary that maps index field values to facet value display names.
         */
        updateCaptions(captions) {
            dispatch(updateFacetSearch({
                facetId,
                captions,
            }));
        },
        get state() {
            const { response, isLoading, options } = getFacetSearch();
            const { query } = options;
            const values = response.values;
            return {
                ...response,
                values,
                isLoading,
                query,
            };
        },
    };
}
